import React from 'react';
import PropTypes from 'prop-types';

export default function BaseDialogLayoutHeader(props) {
  const { footer, footerClassName } = props;

  if (!footer) {
    return null;
  }

  return <footer className={`base-dialog-layout-footer-wrapper ${footerClassName}`}>{footer}</footer>;
}

BaseDialogLayoutHeader.propTypes = {
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  footerClassName: PropTypes.string,
};
